import newShop from '../newShop.js';

newShop.ShippingAddress = function(shippingAddressData){
    "use strict";

    if (shippingAddressData && shippingAddressData !== null) {
        this.buyerId = shippingAddressData.buyerId;
        this.beShippingAddressId = shippingAddressData.beShippingAddressId;
        this.shippingAddressName = shippingAddressData.shippingAddressName;
        this.shippingAddress1 = shippingAddressData.shippingAddress1;
        this.shippingAddress2 = shippingAddressData.shippingAddress2;
        this.shippingAddress3 = shippingAddressData.shippingAddress3;
        this.shippingCity = shippingAddressData.shippingCity;
        this.shippingCounty = shippingAddressData.shippingCounty;
        this.shippingState = shippingAddressData.shippingState;
        this.shippingPostalCode = shippingAddressData.shippingPostalCode;
        this.shippingCountry = shippingAddressData.shippingCountry;
        this.shippingPhone = shippingAddressData.shippingPhone;
        this.shippingMobilePhone = shippingAddressData.shippingMobilePhone;
        this.shippingMobilePhoneCountry = shippingAddressData.shippingMobilePhoneCountry;
        this.shippingInstructions = shippingAddressData.shippingInstructions;
        this.shippingAlias = shippingAddressData.shippingAlias;
        this.addressType = shippingAddressData.addressType;
        this.pickupCenter = shippingAddressData.pickupCenter;
        this.shippingEmail = shippingAddressData.shippingEmail;
        this.shippingPassword = shippingAddressData.shippingPassword;
        this.defaultShipping = shippingAddressData.defaultShipping;
        this.saveShipping = shippingAddressData.saveShipping;
    }

    this.toJSON = function() {
        let shippingAddress = {};
        shippingAddress.beShippingAddressId = this.beShippingAddressId;
        shippingAddress.shippingAddressName = this.shippingAddressName;
        shippingAddress.shippingAddress1 = this.shippingAddress1;
        shippingAddress.shippingAddress2 = this.shippingAddress2;
        shippingAddress.shippingAddress3 = this.shippingAddress3;
        shippingAddress.shippingCity = this.shippingCity;
        shippingAddress.shippingCounty = this.shippingCounty;
        shippingAddress.shippingState = this.shippingState;
        shippingAddress.shippingPostalCode = this.shippingPostalCode;
        shippingAddress.shippingCountry = this.shippingCountry;
        shippingAddress.shippingPhone = this.shippingPhone;
        shippingAddress.shippingMobilePhone = this.shippingMobilePhone;
        shippingAddress.shippingInstructions = this.shippingInstructions;
        shippingAddress.shippingAlias = this.shippingAlias;
        shippingAddress.addressType = this.addressType;
        shippingAddress.pickupCenter = this.pickupCenter;
        shippingAddress.shippingEmail = this.shippingEmail;
        shippingAddress.defaultShipping = this.defaultShipping;
        shippingAddress.saveShipping = this.saveShipping;
        return shippingAddress;
    };


    /*
        This method is only used to convert the shipping address object into the expected shipTo object string
     */
    this.toString = function(){
        let shipToStr = "";

        shipToStr = addFieldStr(shipToStr, 'id:', this.buyerId);
        shipToStr = addFieldStr(shipToStr, 'name:', this.shippingAddressName);
        shipToStr = addFieldStr(shipToStr, 'homePhone:', this.shippingPhone);
        shipToStr = addFieldStr(shipToStr, 'mobilePhone:', this.shippingMobilePhone);
        shipToStr = addFieldStr(shipToStr, 'mobilePhoneCntry:', this.shippingMobilePhoneCountry);
        shipToStr = addFieldStr(shipToStr, 'address1:', this.shippingAddress1);
        shipToStr = addFieldStr(shipToStr, 'address2:', this.shippingAddress2);
        shipToStr = addFieldStr(shipToStr, 'country:', this.shippingCountry);
        shipToStr = addFieldStr(shipToStr, 'city:', this.shippingCity);
        shipToStr = addFieldStr(shipToStr, 'district:', this.shippingState);
        shipToStr = addFieldStr(shipToStr, 'region:', this.shippingCounty);
        shipToStr = addFieldStr(shipToStr, 'postalCode:', this.shippingPostalCode);
        shipToStr = addFieldStr(shipToStr, 'instructions:', this.shippingInstructions);
        shipToStr = addFieldStr(shipToStr, 'email:', this.shippingEmail);

        return shipToStr;
    };

    // ---------------------------------------------
    //
    //        Define all setter methods.
    //
    // ---------------------------------------------
    this.setBuyerId = function(newBuyerId) {
        this.buyerId = newBuyerId;
    };
    this.setBeShippingAddressId  = function(newBeShippingAddressId) {
        this.beShippingAddressId  = newBeShippingAddressId;
    };
    this.setShippingAddressName = function(newShippingAddressName) {
        this.shippingAddressName = newShippingAddressName;
    };
    this.setShippingAddress1 = function(newShippingAddress1) {
        this.shippingAddress1 = newShippingAddress1;
    };
    this.setShippingAddress2 = function(newShippingAddress2) {
        this.shippingAddress2 = newShippingAddress2;
    };
    this.setShippingAddress3 = function(newShippingAddress3) {
        this.shippingAddress3 = newShippingAddress3;
    };
    this.setShippingCity = function(newShippingCity) {
        this.shippingCity = newShippingCity;
    };
    this.setShippingCounty = function(newShippingCounty) {
        this.shippingCounty = newShippingCounty;
    };
    this.setShippingState = function(newShippingState) {
        this.shippingState = newShippingState;
    };
    this.setShippingPostalCode = function(newShippingPostalCode) {
        this.shippingPostalCode = newShippingPostalCode;
    };
    this.setShippingCountry = function(newShippingCountry) {
        this.shippingCountry = newShippingCountry;
    };
    this.setShippingPhone = function(newShippingPhone) {
        this.shippingPhone = newShippingPhone;
    };
    this.setShippingMobilePhone = function(newShippingMobilePhone) {
        this.shippingMobilePhone = newShippingMobilePhone;
    };
    this.setShippingMobilePhoneCountry = function(newShippingMobilePhoneCountry) {
        this.shippingMobilePhoneCountry = newShippingMobilePhoneCountry;
    };
    this.setShippingInstructions = function(newShippingInstructions) {
        this.shippingInstructions = newShippingInstructions;
    };
    this.setShippingAlias = function(newShippingAlias) {
        this.shippingAlias = newShippingAlias;
    };
    this.setAddressType = function(newAddressType) {
        this.addressType = newAddressType;
    };
    this.setPickupCenter = function(newPickupCenter) {
        this.pickupCenter = newPickupCenter;
    };
    this.setShippingEmail = function(newShippingEmail) {
        this.shippingEmail = newShippingEmail;
    };
    this.setShippingPassword = function(newShippingPassword) {
        this.shippingPassword = newShippingPassword;
    }
    this.setDefaultShipping = function(newDefaultShipping) {
        this.defaultShipping = newDefaultShipping;
    };
    this.setSaveShipping = function(newSaveShipping) {
        this.saveShipping = newSaveShipping;
    };

    // ---------------------------------------------
    //
    //        Define all getter methods.
    //
    // ---------------------------------------------
    this.getBuyerId = function() {
        return this.buyerId;
    };
    this.getBeShippingAddressId = function() {
        return this.beShippingAddressId;
    };
    this.getShippingAddressName = function() {
        return this.shippingAddressName;
    };
    this.getShippingAddress1 = function() {
        return this.shippingAddress1;
    };
    this.getShippingAddress2 = function() {
        return this.shippingAddress2;
    };
    this.getShippingAddress3 = function() {
        return this.shippingAddress3;
    };
    this.getShippingCity = function() {
        return this.shippingCity;
    };
    this.getShippingCounty = function() {
        return this.shippingCounty;
    };
    this.getShippingState = function() {
        return this.shippingState;
    };
    this.getShippingPostalCode = function() {
        return this.shippingPostalCode;
    };
    this.getShippingCountry = function() {
        return this.shippingCountry;
    };
    this.getShippingPhone = function() {
        return this.shippingPhone;
    };
    this.getShippingMobilePhone = function() {
        return this.shippingMobilePhone;
    };
    this.getShippingMobilePhoneCountry = function() {
        return this.shippingMobilePhoneCountry;
    };
    this.getShippingInstructions = function() {
        return this.shippingInstructions;
    };
    this.getShippingAlias = function() {
        return this.shippingAlias;
    };
    this.getAddressType = function() {
        return this.addressType;
    };
    this.getPickupCenter = function() {
        return this.pickupCenter;
    };
    this.getShippingEmail = function() {
        return this.shippingEmail;
    };
    this.getShippingPassword = function() {
        return this.getShippingPassword;
    };
    this.getDefaultShipping = function() {
        return this.defaultShipping;
    };
    this.getSaveShipping = function() {
        return this.saveShipping;
    };

    function addFieldStr(shipToStr, fieldLabel, fieldValue){
        if (fieldValue !== undefined && fieldValue !== null && fieldValue.length > 0){
            if (shipToStr.length > 0){
                shipToStr += ",";
            }
            shipToStr += fieldLabel + fieldValue;
        }
        return shipToStr;
    }
};

export default newShop.ShippingAddress;